var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBestRates(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#45355C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.546 9.82h6.546c.15 0 .272.123.272.273v6.545c0 .074-.03.142-.079.194l-9.273 9.272a.28.28 0 01-.193.08.28.28 0 01-.194-.08L9.08 19.56a.275.275 0 010-.387L18.352 9.9c.052-.05.12-.08.194-.08zm2.183 3.271a1.364 1.364 0 102.729 0 1.364 1.364 0 00-2.729 0z",
    fill: "#fff"
  })));
}
export default SvgBestRates;